'use strict';

var _ = require('lodash');
var ConfigurationParametersAdvancedDataProviderService = function ConfigurationParametersAdvancedDataProviderService(restangular, configurationParametersAdvancedService) {
  function getConfigs(configType) {
    return configurationParametersAdvancedService.getConfigs(configType);
  }
  var DEFAULT_NOT_SUPPORTED_TYPES = ['MissingClassPOSDefaultFare', 'FP_MarketConfig', 'FP_TOD_HubBank', 'FP_MetroMarket', 'CurtainRule', 'FlightCurtainRuleId', 'FOBusinessRules', 'FOMinStayGrouping', 'FOMaxStayGrouping', 'FOTaxOverride', 'FOAdvancePurchaseGrouping', 'FOCabinClassConfig', 'FOSeasonLevelMatchThreshold', 'FOUpSellBuyDownConfig', 'FORBDLevelFareThreshold', 'FOFareClassMapping', 'FOAnalystPosMapping', 'FOTacticalFareIndex', 'FOTacticalUserOverrides', 'FONoticePeriod', 'FOInputDataComparisonChecks', 'FOTacticalFBCPatternConfig', 'FOViaPoints', 'DA_RIAWeights', 'FOFareBrandAssignment', 'FOTacticalFareDefinition', 'DA_BookingVelocityODAggregation', 'DA_BookingVelocityPPSAdjustment', 'DA_FareBrandDefinition', 'DA_FareBrandAssignment', 'DA_FareBrandNormalization', 'DA_FareFloorCeiling', 'FOSurchargeManagement'];
  var HEP_TYPES_TO_REMOVE_CARRIER_ATTRIBUTE = ['FOBusinessRules', 'FOFareClassMapping', 'FORBDLevelFareThreshold', 'FOUpSellBuyDownConfig', 'FOSeasonLevelMatchThreshold', 'FOTacticalFareIndex', 'FOTacticalUserOverrides'];
  var HIERARCHIES_NOT_SUPPORTED = [{
    type: 'FP_MarketConfig',
    hierarchy: 'carrier'
  }];
  function isEveryTypeReadOnly() {
    return _.every(getConfigs(), {
      readOnly: true
    });
  }
  function getAttributesLabels(options, configType) {
    return _.reduce(getConfigs(configType), function (result, config) {
      return _.reduce(config.attributes, function (result, attr) {
        var attributeLabelKey = '' + config.type + '.' + config.level + '-' + attr.field;
        result[attributeLabelKey] = options.titleShort && attr.titleShort ? attr.titleShort : attr.title;
        return result;
      }, result);
    }, {});
  }
  function getHepTypesLabels(configType) {
    return _.chain(getConfigs(configType)).uniqBy('type').reduce(function (result, config) {
      result[config.type] = config.description;
      return result;
    }, {}).value();
  }
  function getSupportedHepTypes(configType) {
    return _.chain(getConfigs(configType)).uniqBy('type').reduce(function (result, config) {
      result.push(config.type);
      return result;
    }, []).value();
  }
  function createHierarchyKey(hierarchy) {
    var keyArray = [];
    _.forOwn(hierarchy, function (value) {
      keyArray.push(value);
    });
    return keyArray.join('.');
  }
  function createHierarchyLabel(hierarchyKey, type, options, configType) {
    if (hierarchyKey === 'default') {
      return 'Default';
    }
    var attributesLabels = getAttributesLabels(options, configType);
    var fields = hierarchyKey.split('.');
    if (_.includes(fields, 'legId')) {
      var equalToLegId = _.partial(_.eq, 'legId');
      var legIdFields = ['airlineCode', 'flightNumber', 'departureDate', 'origin', 'destination'];
      var fieldsNotEqualToLegId = _.filter(fields, _.negate(equalToLegId));
      fields = _.concat(legIdFields, fieldsNotEqualToLegId);
    }
    if (_.startsWith(type, 'FO')) {
      if (_.includes(fields, 'cabin')) {
        fields[_.indexOf(fields, 'cabin')] = _.replace(fields[_.indexOf(fields, 'cabin')], 'cabin', 'foCabin');
      }
      if (_.includes(fields, 'carrier')) {
        fields[_.indexOf(fields, 'carrier')] = _.replace(fields[_.indexOf(fields, 'carrier')], 'carrier', 'foCarrier');
      }
    }
    var fieldsWithLabel = _.filter(fields, function (field) {
      return attributesLabels['' + type + '.' + hierarchyKey + '-' + field];
    });
    return _.map(fieldsWithLabel, function (field) {
      return attributesLabels['' + type + '.' + hierarchyKey + '-' + field];
    }).join(' - ');
  }
  function getHierarchiesConfigFromHepMetadata(hierarchies, type, isExpanded) {
    function hierarchyEntry(label, key, isSelected) {
      return {
        key: key,
        label: label,
        isSelected: isSelected
      };
    }
    function addDefaultHierarchy(resultHierarchies) {
      if (isDefaultHierarchyAvailable(type)) {
        resultHierarchies.unshift(hierarchyEntry('Default', 'default', isExpanded));
      } else {
        if (!_.isEmpty(resultHierarchies)) {
          resultHierarchies[0].isSelected = isExpanded;
        }
      }
    }
    function isDefaultHierarchyAvailable(type) {
      return DEFAULT_NOT_SUPPORTED_TYPES.indexOf(type) === -1;
    }
    function isHierarchySupported(type, key) {
      return _.find(HIERARCHIES_NOT_SUPPORTED, {
        type: type,
        hierarchy: key
      }) === undefined;
    }
    var transformHierarchies = function transformHierarchies(hierarchy) {
      var key = createHierarchyKey(hierarchy.attributes);
      var label = createHierarchyLabel(key, type, {
        titleShort: true
      });
      if (isHierarchySupported(type, key)) {
        if (_.startsWith(type, 'FO')) {
          resultHierarchies.push(hierarchyEntry(label, key, false));
        } else {
          resultHierarchies.unshift(hierarchyEntry(label, key, false));
        }
      }
    };
    var resultHierarchies = [];
    _.forEach(hierarchies, transformHierarchies);
    addDefaultHierarchy(resultHierarchies);
    return resultHierarchies;
  }
  function transformHepMetadata(data) {
    var labels = getHepTypesLabels();
    var setLabels = function setLabels(hep) {
      return {
        type: hep.type,
        label: labels[hep.type],
        hierarchies: hep.hierarchies
      };
    };
    var transformHep = function transformHep(hep, index) {
      var isExpandedByDefault = index === 0;
      removeHierarchyForCarrierAttribute(hep);
      hep.hierarchies = getHierarchiesConfigFromHepMetadata(hep.hierarchies, hep.type, isExpandedByDefault);
      hep.isExpanded = isExpandedByDefault;
      return hep;
    };
    return _.chain(data).map(setLabels).sortBy('label').map(transformHep).value();
  }
  function removeHierarchyForCarrierAttribute(hep) {
    if (!HEP_TYPES_TO_REMOVE_CARRIER_ATTRIBUTE.includes(hep.type)) {
      return;
    }
    var index,
      indicesToRemove = [],
      hierarchies = hep.hierarchies;
    for (index = 0; index < hierarchies.length; index += 2) {
      var attribute = _.difference(hierarchies[index].attributes, hierarchies[index + 1].attributes);
      if (_.difference(attribute, ['hostCarrier']).length === 0) {
        indicesToRemove.push(index + 1);
      }
    }
    for (index = indicesToRemove.length - 1; index >= 0; index--) {
      hep.hierarchies.splice(indicesToRemove[index], 1);
    }
  }
  function createFilterQuery(configType) {
    return _.reduce(getSupportedHepTypes(configType), function (result, type) {
      result.push('type==' + type);
      return result;
    }, []).join(' or ');
  }
  function getMetadata(configType) {
    var params = {
      filter: createFilterQuery(configType)
    };
    return restangular.one('configuration').one('hepmetadata').get(params).then(function (data) {
      return transformHepMetadata(data.hepMetadataList);
    });
  }
  function getLabelFromType(type, configType) {
    return getHepTypesLabels(configType)[type];
  }
  return {
    isEveryTypeReadOnly: isEveryTypeReadOnly,
    getLabelFromType: getLabelFromType,
    createHierarchyLabel: createHierarchyLabel,
    getMetadata: getMetadata
  };
};
ConfigurationParametersAdvancedDataProviderService.$inject = ['Restangular', 'ConfigurationParametersAdvancedService'];
module.exports = ConfigurationParametersAdvancedDataProviderService;